const getConnection = state => state.connection;

const getConnectionId = state => state.connectionId;

export default {
    getConnection,
    getConnectionId,
};
